export default {
	"0": {
		"categoria": 'medium',
		"es": {
			"titulo": "Error",
			"cuerpo": "Mensaje del servidor"
		}
	},
	"1": {
		"categoria": 'medium',
		"es": {
			"titulo": "Error",
			"cuerpo": "Se ha producido un error general"
		}
	},
	"2": {
		"categoria": 'important',
		"es": {
			"titulo": "Error",
			"cuerpo": "Se ha perdido la sesión.",
			"aviso": "Por favor vuelva a intentarlo.",
		}
	},
	"3": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Acceso denegado",
			"cuerpo": "El usuario o la contraseña proporcionados no son válidos. Revisa los datos, utiliza la funcionalidad de recuperar contraseña o contacta con nosotros en caso de que tengas cualquier duda."
		}
	},
	"4": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "No se ha encontrado la oferta"
		}
	},
	"6": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "La oferta va dirigida a empleo"
		}
	},
	"7": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "La oferta va dirigida a prácticas"
		}
	},
	"8": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "El dato existía previamente"
		}
	},
	"9": {
		"categoria": 'medium',
		"es": {
			"titulo": "Acceso denegado",
			"cuerpo": "Lo sentimos, el usuario que has indicado o pertenece a una empresa que no está validada en el sistema, o ha sido bloqueado. Por favor contacta con nosotros si si tienes cualquier consulta."
		}
	},
	"10": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "Ya es candidato/a a la oferta"
		}
	},
	"11": {
		"categoria": 'medium',
		"es": {
			"titulo": "Error",
			"cuerpo": "Falta documentación necesaria"
		}
	},
	"12": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "Se ha producido un error enviando el email"
		}
	},
	"13": {
		"categoria": 'medium',
		"es": {
			"titulo": "Error",
			"cuerpo": "La oferta va dirigida a otra titulación perfil.",
			"to": '/'
		},
	},
	"14": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "No puede pasar al estado seleccionado desde el actual"
		}
	},
	"15": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "Faltan datos obligatorios"
		}
	},
	"16": {
		"categoria": 'medium',
		"es": {
			"titulo": "Alta rechazada",
			"cuerpo": "Ya hay un usuario registrado con el email indicado. En caso de no recordar tu usuario o tener cualquier problema, por favor contacta con nosotros."
		}
	},
	"17": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "No puede inscribirse a la oferta porque se solapa con su práctica"
		}
	},
	"18": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "No puede inscribirse a la oferta, es para estudiantes de grado"
		}
	},
	"19": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "No puede inscribirse a la oferta, es para estudiantes de postgrado"
		}
	},
	"20": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "No tiene servicio de empleo"
		}
	},
	"21": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "No tiene servicio de prácticas"
		}
	},
	"22": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "No está identificado como UTP ni como UTE"
		}
	},
	"23": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "No apareces matriculado de prácticas ponte en contacto con nosotros para solucionarlo"
		}
	},
	"24": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "Hay un problema con su empresa. Póngase en contacto con el administrador"
		}
	},
	"25": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "La oferta ya tienen un gestor asociado y no puede editarse, póngase en contacto con él"
		}
	},
	"26": {
		"categoria": 'important',
		"es": {
			"titulo": "Error",
			"cuerpo": "No se han encontrado estudios asociados a tu perfil. Por favor acude a secretaría de alumnos/as para actualizar tu información"
		}
	},
	"27": {
		"categoria": 'medium',
		"es": {
			"titulo": "Error",
			"cuerpo": "Por favor revisa los Datos de la Práctica, la fecha de inicio debe ser anterior a la fecha de finalización de las prácticas."
		}
	},
	"28": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "La contraseña no es segura, debe tener al menos 8 caracteres y un número."
		}
	},
	"29": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "Ya hay un contacto registrado en la empresa con este email"
		}
	},
	"30": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "La candidatura ya ha sido tramitada, no puedes desinscribirte"
		}
	},
	"31": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "No se encuentra la candidatura"
		}
	},
	"32": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "Lo sentimos, estás dado de baja del servicio y no puedes inscribirte a ofertas"
		}
	},
	"33": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "El cif no tiene formato correcto"
		}
	},
	"34": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "El permiso de trabajo es obligatorio para usuarios con nacionalidad distinta a los 28 países de la Unión Europea"
		}
	},
	"35": {
		"categoria": 'medium',
		"es": {
			"titulo": "Error",
			"cuerpo": "La encuesta no es accesible.",
			"to": '/'
		}
	},
	"36": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "La encuesta no es para usuarios existentes.",
			"to": '/'
		}
	},
	"37": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "La encuesta no permite acceso anónimo. Intentan entrar como anonimo pero no se puede.",
			"to": '/'
		}
	},
	"38": {
		"categoria": 'medium',
		"es": {
			"titulo": "Error",
			"cuerpo": "Atención. La encuesta a la que estás tratando de acceder ya no está disponible para tu perfil. No estas en el target de la encuesta.",
			"to": '/'
		},

	},
	"39": {
		"categoria": 'medium',
		"es": {
			"titulo": "Error",
			"cuerpo": "Ya has contestado esta encuesta",
			"to": '/'
		}
	},
	"40": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "Faltan preguntas por contestar"
		}
	},
	"41": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "No se encuentran los estudios de la titulación indicada"
		}
	},
	"42": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "El enlace está caducado o ya ha sido utilizado"
		}
	},
	"43": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Atención",
			"cuerpo": "La contraseña se estableció anteriormente"
		}
	},
	"44": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "El email indicado pertenece a otra empresa, indique otro."
		}
	},
	"45": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "No se encuentra al estudiante de prácticas indicado"
		}
	},
	"46": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "La extensión del archivo no esta permitida"
		}
	},
	"47": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "La oferta va dirigida a otra titulación"
		}
	},
	"48": {
		"categoria": 'medium',
		"es": {
			"titulo": "Error",
			"cuerpo": "Acción no permitida"
		}
	},
	"49": {
		"categoria": 'medium',
		"es": {
			"titulo": "Error",
			"cuerpo": "No puede cambiar el estado"
		}
	},
	"52": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "No tienes superados los créditos necesarios para inscribirte a la oferta"
		}
	},
	"53": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "La oferta va dirigida a estudiantes sin prácticas pendientes"
		}
	},
	"54": {
		"categoria": 'medium',
		"es": {
			"titulo": "Error",
			"cuerpo": "Para poder ser /a a la oferta, se necesita estar en búsqueda activa. Para activarlo dirígete a Mi CV -> Datos de interés"
		}
	},
	"55": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "Es necesario tener subido el CV propio para realizar la operación"
		}
	},
	"56": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "Ya tienes subido este documento, si quieres actualizarlo, elimínalo y vuélvelo a adjuntar."
		}
	},
	"57": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "Es necesario tener al menos una formación para realizar la operación"
		}
	},
	"58": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "La dedicación debe ser la misma que la marcada en el programa 80%. Los meses deben ser los marcados en el programa 12 meses."
		}
	},
	"59": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "Tu usuario no tiene acceso al portal en estos momentos. Por favor, contacta con nosotros ante cualquier duda."
		}
	},
	"60": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "El email ya esta registrado."
		}
	},
	"62": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "No puedes eliminar todos los estudios"
		}
	},
	"63": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "Programa de prácticas no encontrado"
		}
	},
	"64": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "Ya se ha solicitado la adhesión anteriormente"
		}
	},
	"65": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "Este programa no necesita adhesión"
		}
	},
	"66": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "El Documento de Identidad no tiene formato válido"
		}
	},
	"68": {
		"categoria": 'medium',
		"es": {
			"titulo": "Error",
			"cuerpo": "La oferta no es editable"
		}
	},
	"69": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "El email no tiene un formato válido"
		}
	},
	"70": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "El IBAN no tiene un formato válido"
		}
	},
	"71": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "Su usuario no tiene permisos de acceso. Por favor contacte con nosotros en caso de duda"
		}
	},
	"72": {
		"categoria": 'important',
		"es": {
			"titulo": "Error",
			"cuerpo": "Debes añadir el IBAN en tu perfil de empresa",
			"to": '/mi-empresa',
			"blank": true
		},
	},
	"73": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "El IBAN es incorrecto"
		}
	},
	"74": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "Evento no disponible"
		}
	},
	"75": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "Este evento no admite inscritos"
		}
	},
	"76": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "Ya estas inscrito al evento"
		}
	},
	"77": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "El evento es para estudiantes"
		}
	},
	"78": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "El evento es para egresados"
		}
	},
	"79" : {
		"categoria": 'secondary',
		"es": {
			"titulo": "Atención",
			"cuerpo": "El usuario indicado no tiene acceso al Portal. Contacta con nosotros en caso de duda."
		}
	},
	"79" : {
		"categoria": 'secondary',
		"es": {
			"titulo": "Atención",
			"cuerpo": "El usuario indicado no tiene acceso al Portal. Contacta con nosotros en caso de duda."
		}
	},
	"80" : {
		"categoria": 'secondary',
		"es": {
			"titulo": "Atención",
			"cuerpo": "No cumples los requisitos para inscribirte a la oferta"
		}
	},
	"81" : {
		"categoria": 'secondary',
		"es": {
			"titulo": "Atención",
			"cuerpo": "Se ha alcanzado el límite de solicitudes de centro"
		}
	},
	"83": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "El número de la Seguridad Social no es válido"
		}
	},
	"84": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "El SWIFT no es válido"
		}
	},
	"90": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Acceso denegado",
			"cuerpo" : "Usuario bloqueado"
		}
	},
	"91": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Acceso denegado",
			"cuerpo" : "Para inscribirse a una oferta es necesario solicitar la adhesión al programa de prácticas previamente."
		}
	},
	"92": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Acceso denegado",
			"cuerpo" : "Lo sentimos. No puedes inscribirte a esta oferta porque ya ha pasado la fecha límite de aceptación de nuevas inscripciones"
		}
	},
	"93": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Acceso denegado",
			"cuerpo" : "Lo sentimos. No puedes inscribirte a esta oferta mientras tengas candidaturas en otro/s programas. Si tienes cualquier duda respecto a las ofertas que implican la exclusión de candidaturas en otros programas, contacta con nosotros."
		}
	},
	"94": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Error",
			"cuerpo" : "El DNI pertenece a un usuario ya registrado"
		}
	},
	"96": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Atención",
			"cuerpo" : "No puede inscribirse a la oferta, sólo para alumnos con titulaciones asociadas a la Universidad."
		}
	},
	"99": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Atención",
			"cuerpo" : "Sólo los alumnos de USAL o de centros adheridos pueden inscribirse en el programa."
		}
	},
	"106": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Atención",
			"cuerpo" : "No puede adeherirse a este programa ya que la fecha de titulación de sus estudios es anterior a la permitida por el programa."
		}
	},
	"500": {
		"categoria": 'important',
		"es": {
			"titulo": "Error",
			"cuerpo": "El servicio actualmente no esta disponible"
		}
	},
	"501": {
		"categoria": 'secondary',
		"es": {
			"titulo": "¡Enhorabuena!",
			"cuerpo": "Te has desinscrito correctamente"
		}
	},
	"502": {
		"categoria": 'secondary',
		"es": {
			"titulo": "¡Atención!",
			"cuerpo": 'La empresa recibirá tu currículum generado a partir de los datos que has consignado en el menú "Mi perfil". Aségúrate de tenerlo siempre actualizado y lo más completo posible, incluyendo una copia de tu CV personal'
		}
	},
	"503": {
		"categoria": 'important',
		"es": {
			"titulo": "Te has registrado correctamente",
			"cuerpo": "La empresa ha sido dada de alta correctamente. Validaremos los datos facilitados y te enviaremos un mail confirmando tu registro en el menor tiempo posible.",
			"to": '/login/empresas'
		}
	},
	"504": {
		"categoria": 'important',
		"es": {
			"titulo": "Te has registrado correctamente",
			"cuerpo": "Utiliza tu email y la contraseña registrados para logarte en el portal."
		}
	},
	"505": {
		"categoria": 'medium',
		"es": {
			"titulo": "",
			"cuerpo": "Te hemos enviado un enlace de recuperación a tu email."
		}
	},
	"506": {
		"categoria": 'medium',
		"es": {
			"titulo": "¡Muchas gracias!",
			"cuerpo": "Tu oferta ha sido creada correctamente. Te enviaremos un mail avisándote de su activación.",
			"to": '/mis-ofertas'
		}
	},
	"507": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Enhorabuena",
			"cuerpo": "La descripción de la empresa ha sido guardada"
		}
	},
	"508": {
		"categoria": 'important',
		"es": {
			"titulo": "Enhorabuena",
			"cuerpo": "Tu contraseña ha sido restablecida"
		} 
	},
	"509": {
		"categoria": 'medium',
		"es": {
			"titulo": "Error",
			"cuerpo": "No se ha encontrado ningún candidato/a con ese DNI."
		}
	},
	"510": {
		"categoria": 'medium',
		"es": {
			"titulo": "Propuesta de prácticas registrada correctamente",
			"cuerpo": "Tu solicitud ha sido dada de alta correctamente. Revisaremos los datos aportados y te enviaremos un email informándote sobre su validación o rechazo en el menor tiempo posible.",
			"to": '/'
		}
	},
	"511": {
		"categoria": 'medium',
		"es": {
			"titulo": "Enhorabuena",
			"cuerpo": "La oferta ha sido cerrada correctamente",
			"to": "/mis-ofertas"
		}
	},
	"512": {
		"categoria": 'medium',
		"es": {
			"titulo": "¡Muchas gracias!",
			"cuerpo": "Tu oferta ha sido modificada correctamente. Recuerda que solo puedes modificar los detalles de tus ofertas mientras estén “pendiente” de validar y no caducadas",
			"to": '/mis-ofertas'
		}
	},
	"513": {
		"categoria": 'medium',
		"es": {
			"titulo": "¡Enhorabuena!",
			"cuerpo": "Tu documentación ha sido adjuntada correctamente",
		}
	},
	"514": {
		"categoria": 'important',
		"es": {
			"titulo": "Enhorabuena",
			"cuerpo": "Tu contraseña ha sido establecida"
		}
	},
	"515": {
		"categoria": 'medium',
		"es": {
			"titulo": "Atención",
			"cuerpo": "Mensaje del servidor"
		}
	},
	"516": {
		"categoria": 'medium',
		"es": {
			"titulo": "Oferta eliminada",
			"cuerpo": "Tu oferta ha sido eliminada correctamente",
			"to": '/mis-ofertas'
		}
	},
	"517": {
		"categoria": 'medium',
		"es": {
			"titulo": "",
			"cuerpo": "Hemos recibido su solicitud. La tramitaremos e informaremos de la baja definitiva lo antes posible.",
		}
	},
	"518": {
		"categoria": 'medium',
		"es": {
			"titulo": "Atención",
			"cuerpo": "Por favor, completa los datos de número de cuenta y número de Seguridad Social para poder seguir accediendo al portal.",
		}
	},
	"519": {
		"categoria": 'medium',
		"es": {
			"titulo": "",
			"cuerpo": "Tu respuesta a la preinscripción ha sido registrada correctamente",
		}
	},
	"520": {
		"categoria": 'medium',
		"es": {
			"titulo": "Enhorabuena",
			"cuerpo": "Has rechazado tu inscripción correctamente",
		}
	},
	"521": {
		"categoria": 'medium',
		"es": {
			"titulo": "Enhorabuena",
			"cuerpo": "Tu contraseña ha sido cambiada correctamente",
		}
	},
	"522": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Enhorabuena",
			"cuerpo": "Enhorabuena, tu usuario ha sido creado correctamente. Competa tu perfil para acceder todas las ofertas y servicios.",
		}
	},
	"523": {
		"categoria": 'medium',
		"es": {
			"titulo": "Enhorabuena",
			"cuerpo": "Adhesión al programa realizada correctamente.",
			"to": '/programas-practicas-activos'
		}
	},
	"524": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "El email indicado no pertenece a ningún usuario activo de la aplicación. Contacta con nosotros en caso de duda",
		}
	},
	"525": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "Por favor revisa todos los campos"
		}
	},
	"526": {
		"categoria": 'medium',
		"es": {
			"titulo": "Error",
			"cuerpo": "Por favor sube una foto de maximo (1000px)"
		}
	},
	"527": {
		"categoria": 'medium',
		"es": {
			"titulo": "¡Atención!",
			"cuerpo": "El candidato/a no quedará seleccionado si no cumplimentas todos los datos obligatorios de este formulario de selección, que son necesarios para la formalización de prácticas."
		}
	},
	"528": {
		"categoria": 'medium',
		"es": {
			"titulo": "Enhorabuena",
			"cuerpo": "Su solicitud ha sido dada de alta correctamente. Revisaremos los datos aportados y le informaremos sobre su validación o rechazo en el menor tiempo posible. Si no tiene formalizado un convenio de colaboración educativa. Por favor, solicítelo."
		}
	},
	"529": {
		"categoria": 'medium',
		"es": {
			"titulo": "Enviado",
			"cuerpo": "Gracias por tu solicitud, gestionaremos el cambio solicitado a la mayor brevedad posible.",
			"to": '/'
		}
	},
	"530": {
		"categoria": 'medium',
		"es": {
			"titulo": "",
			"cuerpo": "Contacto añadido correctamente",
		}
	},
	"531": {
		"categoria": 'medium',
		"es": {
			"titulo": "",
			"cuerpo": "Cuenta añadida correctamente",
		}
	},
	"532": {
		"categoria": 'medium',
		"es": {
			"titulo": "Muchas gracias",
			"cuerpo": "Convenio añadido correctamente",
			"to": "/"
		}
	},
	"533": {
		"categoria": 'medium',
		"es": {
			"titulo": "Enhorabuena",
			"cuerpo": "Te has inscrito correctamente",
		}
	},
	"534": {
		"categoria" : 'medium',
		"es" : {
			"titulo" : "Atención",
			"cuerpo" : "Cuando registremos tu solicitud, se hará con los datos generados a partir de tu perfil, por favor, completa y/o actualiza el mismo lo más detalladamente posible, incluyendo las notas medias de tus titulaciones oficiales.",
			"to" : '/cv',
			"btn_text" : "Ir a mi CV"
		}
	},
	"530": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Enviado",
			"cuerpo" : "Solicitud rechazada correctamente",
		}
	},
	"531": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Enviado",
			"cuerpo" : "Solicitud aceptada correctamente",
		}
	},
	"532": {
		"categoria" : 'secondary',
		"es" : {
			"titulo" : "Enviado",
			"cuerpo" : "Información actualizada correctamente",
		}
	},
	"533": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Enhorabuena",
			"cuerpo": "Has solicitado la adhesión al programa correctamente",
		}
	},
	"540": {
		"categoria" : 'medium',
		"es" : {
			"titulo" : "Atención",
			"cuerpo" : "Cuando registremos tu solicitud, se hará con los datos generados a partir de tu perfil, por favor, completa y/o actualiza el mismo lo más detalladamente posible.",
			"to" : '/cv',
			"btn_text" : "Ir a mi CV"
		}
	},
	"541": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Atención",
			"cuerpo": "No puedes inscribirte",
		}
	},
	"542": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Lo sentimos",
			"cuerpo": "Este programa solo está disponible para estudiantes de la Universidad de Salamanca o centros de FP asociados.",
		}
	},
	"543": {
		"categoria": 'important',
		"es": {
			"titulo": "Enhorabuena",
			"cuerpo": "Tu contraseña ha sido restablecida",
			"to": '/login/empresas'
		}
	},
	"custom": {
		"categoria": 'medium',
		"es": {
			"titulo": "",
			"cuerpo": ""
		}
	},
	"103": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "No puedes inscribirte en más de 3 ofertas de forma simultánea"
		}
	},
}



// WEBPACK FOOTER //
// ./src/errors/index.js